import { Store } from "pullstate";

interface IUIStore {
  isDarkMode: boolean;
  isLoggedIn: boolean;
  SelectedProperty: {};
  SelectedListings:{};
}

export const UIStore = new Store<IUIStore>({
  isDarkMode: true,
  isLoggedIn: false,
  SelectedProperty: {},
  SelectedListings:{}
});